import { ConnectionZoomFormVM } from '../connection-zoom-form.viewmodel';
import { TConnection } from '../../../../../../../../api/blueprints/connection.template.types';
import { zoomWebinarConfigList } from './connection-zoom-webinar-form.config';
import { ConnectionVersion } from '../../../../../../../../constants/common.constants';

export class ConnectionZoomWebinarFormVM extends ConnectionZoomFormVM {
    constructor(
        connection: TConnection,
        addConnection: (connection: TConnection) => void,
        editConnection: (connection: TConnection) => void,
        isAutoSyncLimitReached: boolean,
        connectionVersion: ConnectionVersion,
    ) {
        super(connection, zoomWebinarConfigList, addConnection, editConnection, connectionVersion, isAutoSyncLimitReached);
    }
}
